import BaseApi from "@/core/HttpResources/BaseApi";

export default class BudgetExecutionService {

  async makeMovementByState(id: Number, state: any): Promise<any> {
    let baseApiPublish = new BaseApi(`ProposalBudgetExecution/MakeMovement/${id}/ByState/${state}`);
    return new Promise<any>((resolve, reject) =>
    baseApiPublish.request(
        "PUT",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async sendFONDOCYT(id: Number): Promise<any> {
    let baseApiPublish = new BaseApi(`ProposalBudgetExecution/SendToFONDOCYT/${id}`);
    return new Promise<any>((resolve, reject) =>
    baseApiPublish.request(
        "PUT",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

  async updateBudgetExecution(
    id: Number,
    data: any
  ): Promise<any> {
    let baseApi = new BaseApi("ProposalBudgetExecution");
    return new Promise<any>((resolve, reject) =>
    baseApi.request(
        "PUT",
        `${id}`,
        data,
        {},
        response => resolve(response.data),
        reject,
        () => { }
      )
    );
  }

}